/*
 * @Description:客户及商机刷新销售订单列表
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-09-08 09:47:12
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
import { salesOrderService } from '@/api/';
import { defineStore } from 'pinia';
import { Message } from '@arco-design/web-vue';
export const useOrderStore = defineStore('getOrderList', {
  state: () => ({
    orderList: [],
    orderParams: {},
    isRefresh: false
  }),
  actions: {
    //获取订单数据列表
    getOrderLists(params) {
      this.orderList = [];
      this.orderParams = params;
      return new Promise((resolve, reject) => {
        salesOrderService
          .getOrderTabList(params)
          .then((json) => {
            if (json.error) {
              Message.error(json.error?.msg || '操作失败');
            }
            this.orderList = json.result;
            resolve(json);
          })
          .catch((err) => {
            Message.error(err.message || err.statusText || '合同订单数据获取失败');
            reject(err);
          });
      });
    },
    //更新是否刷新的标识
    updateRefresh(flag) {
      this.isRefresh = flag;
    }
  }
});

export default useOrderStore;
